import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CardComponentModule, SharedModule } from 'lib-trend-core';
import { DashboardComponent } from './dashboard.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DashboardCrmComponent } from './dashboard-crm/dashboard-crm.component';
import { DashboardTvComponent } from './dashboard-tv/dashboard-tv.component';

@NgModule({
  imports: [
    SharedModule,
    CardComponentModule,
    NgxChartsModule,
    MatTooltipModule
  ],
  declarations: [
    DashboardComponent,
    DashboardCrmComponent,
    DashboardTvComponent,
  ],
  exports: [
    DashboardComponent,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['l', 'LL'],
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule { }
